export default "__VITE_ASSET__28ec83fe__"